import { type AreaRemoveInput, type AreaRemoveSuccess, Logger, toResponseError } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useAreaCache } from './cache'

const logger = new Logger('useRemoveArea')

// logger.level = 'timer'

export function useRemoveArea(): RemoveHookResponse<AreaRemoveInput> {
  logger.verbose('calling useRemoveArea')
  const cache = useAreaCache()
  const mutation = useTantalimMutation<AreaRemoveInput, AreaRemoveSuccess>({ url: '/area/remove' })

  async function remove(input: AreaRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.removeArea(input.areaId, { archive: input.archive !== false })
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
